import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7beb82e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown d-inline-block" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<button type=\"button\" class=\"btn btn-sm btn-icon btn-light btn-active-light-primary me-2\" id=\"dropdownMenuButton\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-7beb82e2><span class=\"svg-icon svg-icon-5 m-0\" data-v-7beb82e2><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-7beb82e2><rect x=\"10\" y=\"10\" width=\"4\" height=\"4\" rx=\"2\" fill=\"currentColor\" data-v-7beb82e2></rect><rect x=\"17\" y=\"10\" width=\"4\" height=\"4\" rx=\"2\" fill=\"currentColor\" data-v-7beb82e2></rect><rect x=\"3\" y=\"10\" width=\"4\" height=\"4\" rx=\"2\" fill=\"currentColor\" data-v-7beb82e2></rect></svg></span></button>", 1)
const _hoisted_3 = { class: "dropdown-menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "dropdown-item",
    href: "#"
  }, "Rename")
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "#"
}, "Download Folder", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "dropdown-item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelectViewOption(_ctx.item)))
        }, "View")
      ]),
      _hoisted_4,
      (_ctx.isFolder)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "dropdown-item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectDeleteOption(_ctx.item))),
          href: "#"
        }, "Delete")
      ])
    ])
  ]))
}